// extracted by mini-css-extract-plugin
export default {"root":"TourDescription_root__ecghN"};